import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgLineComponent } from './svgline.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgLineComponent],
  exports: [SvgLineComponent]
})
export class SvgLineModule { }
